module.exports = __webpack_public_path__ + "static/fonts/Fact-Black.a039d69.ttf";